/**
 * Firestore data types
 */

export type BlockType = 'link' | 'post';

export interface Block {
  id: string;
  type: BlockType;
  title: string;
  url?: string;
  content?: string;
  imageUrl?: string;
  order: number;
  enabled: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface UserProfile {
  uid: string;
  username: string;
  displayName: string;
  bio: string;
  avatarUrl: string;
  theme: Theme;
  layout: Layout;
  createdAt: Date;
  updatedAt: Date;
}

export interface Theme {
  id: string;
  name: string;
  primaryColor: string;
  secondaryColor: string;
  backgroundColor: string;
}

export interface Layout {
  id: string;
  name: string;
}

export interface UsernameMapping {
  uid: string;
}

export const THEMES: Theme[] = [
  {
    id: 'default',
    name: 'Pink Pop',
    primaryColor: '#FF6B9D',
    secondaryColor: '#A855F7',
    backgroundColor: '#FFF5F7',
  },
  {
    id: 'purple',
    name: 'Purple Dreams',
    primaryColor: '#A855F7',
    secondaryColor: '#6366F1',
    backgroundColor: '#F5F3FF',
  },
  {
    id: 'blue',
    name: 'Ocean Breeze',
    primaryColor: '#3B82F6',
    secondaryColor: '#06B6D4',
    backgroundColor: '#F0F9FF',
  },
];

export const LAYOUTS: Layout[] = [
  { id: 'stack', name: 'Stack' },
  { id: 'grid', name: 'Grid' },
  { id: 'list', name: 'List' },
];
